import { useNavigate } from "react-router-dom";
import { Register } from "../components/register";
import { RegistrationValues } from "../components/register/types/registration";
import { useAuthStore } from "../auth/auth.store";

function RegisterRoute({ googleEnabled }: { googleEnabled: boolean }) {
  const navigate = useNavigate();
  const register = useAuthStore((state) => state.register);
  const googleAuth = useAuthStore((state) => state.googleAuth);

  return (
    <Register
      onSubmitRegistration={async (data: RegistrationValues) => {
        await register(data);
        navigate("/verify");
      }}
      onGoogleIndividualLogin={async ({ accessToken }) => {
        await googleAuth(accessToken);
        navigate("/success");
      }}
      googleEnabled={googleEnabled}
    />
  );
}


export default RegisterRoute;